// extracted by mini-css-extract-plugin
export var banner = "_jd-0";
export var closeButton = "_jd-2";
export var greenCheckmark = "_jd-3";
export var hereLink = "_jd-4";
export var titleIcon = "_jd-1";